// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.updatedata_dataUpdateContainer__MMyzg {
  padding: 20px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin: 20px 0;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_header__iNzGK {
  margin-bottom: 30px;
  text-align: center;
  border-bottom: 2px solid #0467a0;
  padding-bottom: 20px;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_header__iNzGK h2 {
  color: #0467a0;
  font-size: 28px;
  font-weight: bold;
  margin: 0 0 10px 0;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_header__iNzGK .updatedata_subtitle__Rfvii {
  color: #666;
  font-size: 16px;
  margin: 0;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_controlsContainer__bj8Bt {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  gap: 20px;
  flex-wrap: wrap;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_controlsContainer__bj8Bt .updatedata_searchSection__TfIza {
  flex: 1 1;
  min-width: 300px;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_controlsContainer__bj8Bt .updatedata_searchSection__TfIza .updatedata_searchBox__aC2-u {
  position: relative;
  margin-bottom: 15px;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_controlsContainer__bj8Bt .updatedata_searchSection__TfIza .updatedata_searchBox__aC2-u .updatedata_searchInput__-NRzg {
  width: 100%;
  padding: 12px 45px 12px 15px;
  border: 2px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.3s ease;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_controlsContainer__bj8Bt .updatedata_searchSection__TfIza .updatedata_searchBox__aC2-u .updatedata_searchInput__-NRzg:focus {
  outline: none;
  border-color: #0467a0;
  box-shadow: 0 0 0 3px rgba(4, 103, 160, 0.1);
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_controlsContainer__bj8Bt .updatedata_searchSection__TfIza .updatedata_searchBox__aC2-u .updatedata_searchInput__-NRzg::placeholder {
  color: #999;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_controlsContainer__bj8Bt .updatedata_searchSection__TfIza .updatedata_searchBox__aC2-u .updatedata_searchButton__oH9qO {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: #0467a0;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_controlsContainer__bj8Bt .updatedata_searchSection__TfIza .updatedata_filterSection__uDKKU {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_controlsContainer__bj8Bt .updatedata_searchSection__TfIza .updatedata_filterSection__uDKKU .updatedata_filterInput__wKsmh {
  flex: 1 1;
  min-width: 150px;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_controlsContainer__bj8Bt .updatedata_searchSection__TfIza .updatedata_filterSection__uDKKU .updatedata_filterInput__wKsmh:focus {
  outline: none;
  border-color: #0467a0;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_controlsContainer__bj8Bt .updatedata_actionsSection__pNzej {
  display: flex;
  flex-direction: column;
  gap: 15px;
  min-width: 200px;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_controlsContainer__bj8Bt .updatedata_actionsSection__pNzej .updatedata_sortSection__yXJtm {
  display: flex;
  align-items: center;
  gap: 10px;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_controlsContainer__bj8Bt .updatedata_actionsSection__pNzej .updatedata_sortSection__yXJtm label {
  font-weight: 500;
  color: #333;
  white-space: nowrap;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_controlsContainer__bj8Bt .updatedata_actionsSection__pNzej .updatedata_sortSection__yXJtm .updatedata_sortSelect__h8YFH {
  padding: 6px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  background: white;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_controlsContainer__bj8Bt .updatedata_actionsSection__pNzej .updatedata_sortSection__yXJtm .updatedata_sortSelect__h8YFH:focus {
  outline: none;
  border-color: #0467a0;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_controlsContainer__bj8Bt .updatedata_actionsSection__pNzej .updatedata_sortSection__yXJtm .updatedata_sortButton__xgaMv {
  padding: 6px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: white;
  cursor: pointer;
  font-size: 16px;
  color: #0467a0;
  transition: all 0.3s ease;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_controlsContainer__bj8Bt .updatedata_actionsSection__pNzej .updatedata_sortSection__yXJtm .updatedata_sortButton__xgaMv:hover {
  background: #0467a0;
  color: white;
  border-color: #0467a0;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_controlsContainer__bj8Bt .updatedata_actionsSection__pNzej .updatedata_itemsPerPageContainer__57jN3 {
  display: flex;
  align-items: center;
  gap: 10px;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_controlsContainer__bj8Bt .updatedata_actionsSection__pNzej .updatedata_itemsPerPageContainer__57jN3 label {
  font-weight: 500;
  color: #333;
  white-space: nowrap;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_controlsContainer__bj8Bt .updatedata_actionsSection__pNzej .updatedata_itemsPerPageContainer__57jN3 .updatedata_itemsPerPageSelect__nVSXt {
  padding: 6px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  background: white;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_controlsContainer__bj8Bt .updatedata_actionsSection__pNzej .updatedata_itemsPerPageContainer__57jN3 .updatedata_itemsPerPageSelect__nVSXt:focus {
  outline: none;
  border-color: #0467a0;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_bulkActionsContainer__k2stU {
  margin-bottom: 20px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e9ecef;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_bulkActionsContainer__k2stU .updatedata_bulkActionsHeader__sfdbJ {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 15px;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_bulkActionsContainer__k2stU .updatedata_bulkActionsHeader__sfdbJ .updatedata_selectAllLabel__3\\+pPn {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
  color: #333;
  cursor: pointer;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_bulkActionsContainer__k2stU .updatedata_bulkActionsHeader__sfdbJ .updatedata_selectAllLabel__3\\+pPn .updatedata_selectAllCheckbox__3VsRj {
  width: 18px;
  height: 18px;
  cursor: pointer;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_bulkActionsContainer__k2stU .updatedata_bulkActionsHeader__sfdbJ .updatedata_bulkActionButtons__iC3B8 {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_bulkActionsContainer__k2stU .updatedata_bulkActionsHeader__sfdbJ .updatedata_bulkActionButtons__iC3B8 .updatedata_bulkActionButton__iBRu- {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 5px;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_bulkActionsContainer__k2stU .updatedata_bulkActionsHeader__sfdbJ .updatedata_bulkActionButtons__iC3B8 .updatedata_bulkActionButton__iBRu-.updatedata_deleteButton__fad2g {
  background: #ff0000;
  color: white;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_bulkActionsContainer__k2stU .updatedata_bulkActionsHeader__sfdbJ .updatedata_bulkActionButtons__iC3B8 .updatedata_bulkActionButton__iBRu-.updatedata_deleteButton__fad2g:hover {
  background: #cc0000;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_bulkActionsContainer__k2stU .updatedata_bulkActionsHeader__sfdbJ .updatedata_bulkActionButtons__iC3B8 .updatedata_bulkActionButton__iBRu-.updatedata_exportButton__ebeTh {
  background: #0467a0;
  color: white;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_bulkActionsContainer__k2stU .updatedata_bulkActionsHeader__sfdbJ .updatedata_bulkActionButtons__iC3B8 .updatedata_bulkActionButton__iBRu-.updatedata_exportButton__ebeTh:hover {
  background: #035a8a;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_loadingContainer__2vXHz {
  text-align: center;
  padding: 40px;
  color: #666;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_loadingContainer__2vXHz .updatedata_loadingSpinner__KtoUF {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #0467a0;
  border-radius: 50%;
  animation: updatedata_spin__RcrHi 1s linear infinite;
  margin: 0 auto 20px;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_loadingContainer__2vXHz p {
  font-size: 16px;
  margin: 0;
}
@keyframes updatedata_spin__RcrHi {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_tableContainer__umkHQ {
  overflow-x: auto;
  border-radius: 6px;
  border: 1px solid #e9ecef;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_tableContainer__umkHQ .updatedata_table__IzbIH {
  width: 100%;
  border-collapse: collapse;
  background: white;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_tableContainer__umkHQ .updatedata_table__IzbIH th, .updatedata_dataUpdateContainer__MMyzg .updatedata_tableContainer__umkHQ .updatedata_table__IzbIH td {
  padding: 12px 8px;
  text-align: left;
  border-bottom: 1px solid #e9ecef;
  font-size: 14px;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_tableContainer__umkHQ .updatedata_table__IzbIH th {
  background: #0467a0;
  color: white;
  font-weight: 600;
  position: sticky;
  top: 0;
  z-index: 10;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_tableContainer__umkHQ .updatedata_table__IzbIH th.updatedata_checkboxColumn__KUAYo {
  width: 50px;
  text-align: center;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_tableContainer__umkHQ .updatedata_table__IzbIH td.updatedata_checkboxColumn__KUAYo {
  width: 50px;
  text-align: center;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_tableContainer__umkHQ .updatedata_table__IzbIH td.updatedata_formNumber__hXZaa {
  font-weight: 500;
  color: #0467a0;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_tableContainer__umkHQ .updatedata_table__IzbIH td.updatedata_officeName__obeo- {
  font-weight: 500;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_tableContainer__umkHQ .updatedata_table__IzbIH td.updatedata_ledgerPage__D837B {
  font-weight: 500;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_tableContainer__umkHQ .updatedata_table__IzbIH td.updatedata_itemName__PbbsY {
  font-weight: 500;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_tableContainer__umkHQ .updatedata_table__IzbIH td.updatedata_officeAddress__Q1zIm {
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_tableContainer__umkHQ .updatedata_table__IzbIH td.updatedata_actionButtons__HqLmm {
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
  min-width: 200px;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_tableContainer__umkHQ .updatedata_table__IzbIH td.updatedata_actionButtons__HqLmm .updatedata_actionButton__kKiBj {
  padding: 6px 10px;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 3px;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_tableContainer__umkHQ .updatedata_table__IzbIH td.updatedata_actionButtons__HqLmm .updatedata_actionButton__kKiBj.updatedata_editButton__O2yBV {
  background: #0467a0;
  color: white;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_tableContainer__umkHQ .updatedata_table__IzbIH td.updatedata_actionButtons__HqLmm .updatedata_actionButton__kKiBj.updatedata_editButton__O2yBV:hover {
  background: #035a8a;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_tableContainer__umkHQ .updatedata_table__IzbIH td.updatedata_actionButtons__HqLmm .updatedata_actionButton__kKiBj.updatedata_viewButton__iAnEs {
  background: #28a745;
  color: white;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_tableContainer__umkHQ .updatedata_table__IzbIH td.updatedata_actionButtons__HqLmm .updatedata_actionButton__kKiBj.updatedata_viewButton__iAnEs:hover {
  background: #218838;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_tableContainer__umkHQ .updatedata_table__IzbIH td.updatedata_actionButtons__HqLmm .updatedata_actionButton__kKiBj.updatedata_duplicateButton__R6IG\\+ {
  background: #ffc107;
  color: #212529;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_tableContainer__umkHQ .updatedata_table__IzbIH td.updatedata_actionButtons__HqLmm .updatedata_actionButton__kKiBj.updatedata_duplicateButton__R6IG\\+:hover {
  background: #e0a800;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_tableContainer__umkHQ .updatedata_table__IzbIH tbody tr {
  transition: background-color 0.3s ease;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_tableContainer__umkHQ .updatedata_table__IzbIH tbody tr:hover {
  background: #f8f9fa;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_tableContainer__umkHQ .updatedata_table__IzbIH tbody tr.updatedata_selectedRow__IKOka {
  background: #e3f2fd;
  border-left: 4px solid #0467a0;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_paginationContainer__Iw3uG {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e9ecef;
  flex-wrap: wrap;
  gap: 15px;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_paginationContainer__Iw3uG .updatedata_paginationInfo__-i1Zd {
  font-weight: 500;
  color: #333;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_paginationContainer__Iw3uG .updatedata_paginationButtons__REHsU {
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_paginationContainer__Iw3uG .updatedata_paginationButtons__REHsU .updatedata_paginationButton__hqn\\+l {
  padding: 8px 12px;
  border: 1px solid #ddd;
  background: white;
  color: #333;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s ease;
  min-width: 40px;
  text-align: center;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_paginationContainer__Iw3uG .updatedata_paginationButtons__REHsU .updatedata_paginationButton__hqn\\+l:hover:not(:disabled) {
  background: #0467a0;
  color: white;
  border-color: #0467a0;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_paginationContainer__Iw3uG .updatedata_paginationButtons__REHsU .updatedata_paginationButton__hqn\\+l:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_paginationContainer__Iw3uG .updatedata_paginationButtons__REHsU .updatedata_paginationButton__hqn\\+l.updatedata_activePage__XYGOE {
  background: #0467a0;
  color: white;
  border-color: #0467a0;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_noDataContainer__SvIjC {
  text-align: center;
  padding: 60px 20px;
  color: #666;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_noDataContainer__SvIjC .updatedata_noDataIcon__8In-v {
  font-size: 48px;
  margin-bottom: 20px;
  opacity: 0.5;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_noDataContainer__SvIjC p {
  font-size: 18px;
  margin: 0 0 10px 0;
  font-weight: 500;
}
.updatedata_dataUpdateContainer__MMyzg .updatedata_noDataContainer__SvIjC .updatedata_noDataSubtext__TwS4C {
  font-size: 14px;
  color: #999;
  margin: 0;
}
@media (max-width: 768px) {
  .updatedata_dataUpdateContainer__MMyzg .updatedata_controlsContainer__bj8Bt {
    flex-direction: column;
  }
  .updatedata_dataUpdateContainer__MMyzg .updatedata_controlsContainer__bj8Bt .updatedata_searchSection__TfIza {
    min-width: 100%;
  }
  .updatedata_dataUpdateContainer__MMyzg .updatedata_controlsContainer__bj8Bt .updatedata_actionsSection__pNzej {
    min-width: 100%;
    flex-direction: row;
    justify-content: space-between;
  }
  .updatedata_dataUpdateContainer__MMyzg .updatedata_bulkActionsContainer__k2stU .updatedata_bulkActionsHeader__sfdbJ {
    flex-direction: column;
    align-items: flex-start;
  }
  .updatedata_dataUpdateContainer__MMyzg .updatedata_tableContainer__umkHQ .updatedata_table__IzbIH th, .updatedata_dataUpdateContainer__MMyzg .updatedata_tableContainer__umkHQ .updatedata_table__IzbIH td {
    padding: 8px 4px;
    font-size: 12px;
  }
  .updatedata_dataUpdateContainer__MMyzg .updatedata_tableContainer__umkHQ .updatedata_table__IzbIH td.updatedata_actionButtons__HqLmm {
    flex-direction: column;
    gap: 3px;
  }
  .updatedata_dataUpdateContainer__MMyzg .updatedata_tableContainer__umkHQ .updatedata_table__IzbIH td.updatedata_actionButtons__HqLmm .updatedata_actionButton__kKiBj {
    width: 100%;
    justify-content: center;
  }
  .updatedata_dataUpdateContainer__MMyzg .updatedata_paginationContainer__Iw3uG {
    flex-direction: column;
    text-align: center;
  }
  .updatedata_dataUpdateContainer__MMyzg .updatedata_paginationContainer__Iw3uG .updatedata_paginationButtons__REHsU {
    justify-content: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/StoreForm/403/updatedata.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,wCAAA;EACA,cAAA;AACF;AACE;EACE,mBAAA;EACA,kBAAA;EACA,gCAAA;EACA,oBAAA;AACJ;AACI;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AACN;AAEI;EACE,WAAA;EACA,eAAA;EACA,SAAA;AAAN;AAIE;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAFJ;AAII;EACE,SAAA;EACA,gBAAA;AAFN;AAIM;EACE,kBAAA;EACA,mBAAA;AAFR;AAIQ;EACE,WAAA;EACA,4BAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,kCAAA;AAFV;AAIU;EACE,aAAA;EACA,qBAAA;EACA,4CAAA;AAFZ;AAKU;EACE,WAAA;AAHZ;AAOQ;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;AALV;AASM;EACE,aAAA;EACA,SAAA;EACA,eAAA;AAPR;AASQ;EACE,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;AAPV;AASU;EACE,aAAA;EACA,qBAAA;AAPZ;AAaI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AAXN;AAaM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAXR;AAaQ;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;AAXV;AAcQ;EACE,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AAZV;AAcU;EACE,aAAA;EACA,qBAAA;AAZZ;AAgBQ;EACE,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;AAdV;AAgBU;EACE,mBAAA;EACA,YAAA;EACA,qBAAA;AAdZ;AAmBM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAjBR;AAmBQ;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;AAjBV;AAoBQ;EACE,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AAlBV;AAoBU;EACE,aAAA;EACA,qBAAA;AAlBZ;AAyBE;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AAvBJ;AAyBI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AAvBN;AAyBM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AAvBR;AAyBQ;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAvBV;AA2BM;EACE,aAAA;EACA,SAAA;EACA,eAAA;AAzBR;AA2BQ;EACE,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAzBV;AA2BU;EACE,mBAAA;EACA,YAAA;AAzBZ;AA2BY;EACE,mBAAA;AAzBd;AA6BU;EACE,mBAAA;EACA,YAAA;AA3BZ;AA6BY;EACE,mBAAA;AA3Bd;AAmCE;EACE,kBAAA;EACA,aAAA;EACA,WAAA;AAjCJ;AAmCI;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,oDAAA;EACA,mBAAA;AAjCN;AAoCI;EACE,eAAA;EACA,SAAA;AAlCN;AAsCE;EACE;IAAK,uBAAA;EAnCP;EAoCE;IAAO,yBAAA;EAjCT;AACF;AAmCE;EACE,gBAAA;EACA,kBAAA;EACA,yBAAA;AAjCJ;AAmCI;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;AAjCN;AAmCM;EACE,iBAAA;EACA,gBAAA;EACA,gCAAA;EACA,eAAA;AAjCR;AAoCM;EACE,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,MAAA;EACA,WAAA;AAlCR;AAoCQ;EACE,WAAA;EACA,kBAAA;AAlCV;AAuCQ;EACE,WAAA;EACA,kBAAA;AArCV;AAwCQ;EACE,gBAAA;EACA,cAAA;AAtCV;AAyCQ;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAvCV;AA0CQ;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAxCV;AA2CQ;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAzCV;AA4CQ;EACE,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA1CV;AA6CQ;EACE,aAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;AA3CV;AA6CU;EACE,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AA3CZ;AA6CY;EACE,mBAAA;EACA,YAAA;AA3Cd;AA6Cc;EACE,mBAAA;AA3ChB;AA+CY;EACE,mBAAA;EACA,YAAA;AA7Cd;AA+Cc;EACE,mBAAA;AA7ChB;AAiDY;EACE,mBAAA;EACA,cAAA;AA/Cd;AAiDc;EACE,mBAAA;AA/ChB;AAuDQ;EACE,sCAAA;AArDV;AAuDU;EACE,mBAAA;AArDZ;AAwDU;EACE,mBAAA;EACA,8BAAA;AAtDZ;AA6DE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,SAAA;AA3DJ;AA6DI;EACE,gBAAA;EACA,WAAA;AA3DN;AA8DI;EACE,aAAA;EACA,QAAA;EACA,eAAA;AA5DN;AA8DM;EACE,iBAAA;EACA,sBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;AA5DR;AA8DQ;EACE,mBAAA;EACA,YAAA;EACA,qBAAA;AA5DV;AA+DQ;EACE,YAAA;EACA,mBAAA;AA7DV;AAgEQ;EACE,mBAAA;EACA,YAAA;EACA,qBAAA;AA9DV;AAoEE;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;AAlEJ;AAoEI;EACE,eAAA;EACA,mBAAA;EACA,YAAA;AAlEN;AAqEI;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;AAnEN;AAsEI;EACE,eAAA;EACA,WAAA;EACA,SAAA;AApEN;AAyEE;EACE;IACE,sBAAA;EAvEJ;EAyEI;IACE,eAAA;EAvEN;EA0EI;IACE,eAAA;IACA,mBAAA;IACA,8BAAA;EAxEN;EA6EI;IACE,sBAAA;IACA,uBAAA;EA3EN;EAiFM;IACE,gBAAA;IACA,eAAA;EA/ER;EAkFM;IACE,sBAAA;IACA,QAAA;EAhFR;EAkFQ;IACE,WAAA;IACA,uBAAA;EAhFV;EAsFE;IACE,sBAAA;IACA,kBAAA;EApFJ;EAsFI;IACE,uBAAA;EApFN;AACF","sourcesContent":[".dataUpdateContainer {\n  padding: 20px;\n  background: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  margin: 20px 0;\n\n  .header {\n    margin-bottom: 30px;\n    text-align: center;\n    border-bottom: 2px solid #0467a0;\n    padding-bottom: 20px;\n\n    h2 {\n      color: #0467a0;\n      font-size: 28px;\n      font-weight: bold;\n      margin: 0 0 10px 0;\n    }\n\n    .subtitle {\n      color: #666;\n      font-size: 16px;\n      margin: 0;\n    }\n  }\n\n  .controlsContainer {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    margin-bottom: 20px;\n    gap: 20px;\n    flex-wrap: wrap;\n\n    .searchSection {\n      flex: 1;\n      min-width: 300px;\n\n      .searchBox {\n        position: relative;\n        margin-bottom: 15px;\n\n        .searchInput {\n          width: 100%;\n          padding: 12px 45px 12px 15px;\n          border: 2px solid #ddd;\n          border-radius: 6px;\n          font-size: 14px;\n          transition: border-color 0.3s ease;\n\n          &:focus {\n            outline: none;\n            border-color: #0467a0;\n            box-shadow: 0 0 0 3px rgba(4, 103, 160, 0.1);\n          }\n\n          &::placeholder {\n            color: #999;\n          }\n        }\n\n        .searchButton {\n          position: absolute;\n          right: 10px;\n          top: 50%;\n          transform: translateY(-50%);\n          background: none;\n          border: none;\n          font-size: 18px;\n          cursor: pointer;\n          color: #0467a0;\n        }\n      }\n\n      .filterSection {\n        display: flex;\n        gap: 10px;\n        flex-wrap: wrap;\n\n        .filterInput {\n          flex: 1;\n          min-width: 150px;\n          padding: 8px 12px;\n          border: 1px solid #ddd;\n          border-radius: 4px;\n          font-size: 14px;\n\n          &:focus {\n            outline: none;\n            border-color: #0467a0;\n          }\n        }\n      }\n    }\n\n    .actionsSection {\n      display: flex;\n      flex-direction: column;\n      gap: 15px;\n      min-width: 200px;\n\n      .sortSection {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n\n        label {\n          font-weight: 500;\n          color: #333;\n          white-space: nowrap;\n        }\n\n        .sortSelect {\n          padding: 6px 10px;\n          border: 1px solid #ddd;\n          border-radius: 4px;\n          font-size: 14px;\n          background: white;\n\n          &:focus {\n            outline: none;\n            border-color: #0467a0;\n          }\n        }\n\n        .sortButton {\n          padding: 6px 10px;\n          border: 1px solid #ddd;\n          border-radius: 4px;\n          background: white;\n          cursor: pointer;\n          font-size: 16px;\n          color: #0467a0;\n          transition: all 0.3s ease;\n\n          &:hover {\n            background: #0467a0;\n            color: white;\n            border-color: #0467a0;\n          }\n        }\n      }\n\n      .itemsPerPageContainer {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n\n        label {\n          font-weight: 500;\n          color: #333;\n          white-space: nowrap;\n        }\n\n        .itemsPerPageSelect {\n          padding: 6px 10px;\n          border: 1px solid #ddd;\n          border-radius: 4px;\n          font-size: 14px;\n          background: white;\n\n          &:focus {\n            outline: none;\n            border-color: #0467a0;\n          }\n        }\n      }\n    }\n  }\n\n  .bulkActionsContainer {\n    margin-bottom: 20px;\n    padding: 15px;\n    background: #f8f9fa;\n    border-radius: 6px;\n    border: 1px solid #e9ecef;\n\n    .bulkActionsHeader {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      flex-wrap: wrap;\n      gap: 15px;\n\n      .selectAllLabel {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        font-weight: 500;\n        color: #333;\n        cursor: pointer;\n\n        .selectAllCheckbox {\n          width: 18px;\n          height: 18px;\n          cursor: pointer;\n        }\n      }\n\n      .bulkActionButtons {\n        display: flex;\n        gap: 10px;\n        flex-wrap: wrap;\n\n        .bulkActionButton {\n          padding: 8px 16px;\n          border: none;\n          border-radius: 4px;\n          font-size: 14px;\n          font-weight: 500;\n          cursor: pointer;\n          transition: all 0.3s ease;\n          display: flex;\n          align-items: center;\n          gap: 5px;\n\n          &.deleteButton {\n            background: #ff0000;\n            color: white;\n\n            &:hover {\n              background: #cc0000;\n            }\n          }\n\n          &.exportButton {\n            background: #0467a0;\n            color: white;\n\n            &:hover {\n              background: #035a8a;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .loadingContainer {\n    text-align: center;\n    padding: 40px;\n    color: #666;\n\n    .loadingSpinner {\n      width: 40px;\n      height: 40px;\n      border: 4px solid #f3f3f3;\n      border-top: 4px solid #0467a0;\n      border-radius: 50%;\n      animation: spin 1s linear infinite;\n      margin: 0 auto 20px;\n    }\n\n    p {\n      font-size: 16px;\n      margin: 0;\n    }\n  }\n\n  @keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n  }\n\n  .tableContainer {\n    overflow-x: auto;\n    border-radius: 6px;\n    border: 1px solid #e9ecef;\n\n    .table {\n      width: 100%;\n      border-collapse: collapse;\n      background: white;\n\n      th, td {\n        padding: 12px 8px;\n        text-align: left;\n        border-bottom: 1px solid #e9ecef;\n        font-size: 14px;\n      }\n\n      th {\n        background: #0467a0;\n        color: white;\n        font-weight: 600;\n        position: sticky;\n        top: 0;\n        z-index: 10;\n\n        &.checkboxColumn {\n          width: 50px;\n          text-align: center;\n        }\n      }\n\n      td {\n        &.checkboxColumn {\n          width: 50px;\n          text-align: center;\n        }\n\n        &.formNumber {\n          font-weight: 500;\n          color: #0467a0;\n        }\n\n        &.officeName {\n          font-weight: 500;\n          max-width: 200px;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n        }\n\n        &.ledgerPage {\n          font-weight: 500;\n          max-width: 150px;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n        }\n\n        &.itemName {\n          font-weight: 500;\n          max-width: 200px;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n        }\n\n        &.officeAddress {\n          max-width: 250px;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n        }\n\n        &.actionButtons {\n          display: flex;\n          gap: 5px;\n          flex-wrap: wrap;\n          min-width: 200px;\n\n          .actionButton {\n            padding: 6px 10px;\n            border: none;\n            border-radius: 4px;\n            font-size: 12px;\n            font-weight: 500;\n            cursor: pointer;\n            transition: all 0.3s ease;\n            display: flex;\n            align-items: center;\n            gap: 3px;\n\n            &.editButton {\n              background: #0467a0;\n              color: white;\n\n              &:hover {\n                background: #035a8a;\n              }\n            }\n\n            &.viewButton {\n              background: #28a745;\n              color: white;\n\n              &:hover {\n                background: #218838;\n              }\n            }\n\n            &.duplicateButton {\n              background: #ffc107;\n              color: #212529;\n\n              &:hover {\n                background: #e0a800;\n              }\n            }\n          }\n        }\n      }\n\n      tbody {\n        tr {\n          transition: background-color 0.3s ease;\n\n          &:hover {\n            background: #f8f9fa;\n          }\n\n          &.selectedRow {\n            background: #e3f2fd;\n            border-left: 4px solid #0467a0;\n          }\n        }\n      }\n    }\n  }\n\n  .paginationContainer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 20px;\n    padding: 15px;\n    background: #f8f9fa;\n    border-radius: 6px;\n    border: 1px solid #e9ecef;\n    flex-wrap: wrap;\n    gap: 15px;\n\n    .paginationInfo {\n      font-weight: 500;\n      color: #333;\n    }\n\n    .paginationButtons {\n      display: flex;\n      gap: 5px;\n      flex-wrap: wrap;\n\n      .paginationButton {\n        padding: 8px 12px;\n        border: 1px solid #ddd;\n        background: white;\n        color: #333;\n        border-radius: 4px;\n        cursor: pointer;\n        font-size: 14px;\n        transition: all 0.3s ease;\n        min-width: 40px;\n        text-align: center;\n\n        &:hover:not(:disabled) {\n          background: #0467a0;\n          color: white;\n          border-color: #0467a0;\n        }\n\n        &:disabled {\n          opacity: 0.5;\n          cursor: not-allowed;\n        }\n\n        &.activePage {\n          background: #0467a0;\n          color: white;\n          border-color: #0467a0;\n        }\n      }\n    }\n  }\n\n  .noDataContainer {\n    text-align: center;\n    padding: 60px 20px;\n    color: #666;\n\n    .noDataIcon {\n      font-size: 48px;\n      margin-bottom: 20px;\n      opacity: 0.5;\n    }\n\n    p {\n      font-size: 18px;\n      margin: 0 0 10px 0;\n      font-weight: 500;\n    }\n\n    .noDataSubtext {\n      font-size: 14px;\n      color: #999;\n      margin: 0;\n    }\n  }\n\n  // Responsive design\n  @media (max-width: 768px) {\n    .controlsContainer {\n      flex-direction: column;\n\n      .searchSection {\n        min-width: 100%;\n      }\n\n      .actionsSection {\n        min-width: 100%;\n        flex-direction: row;\n        justify-content: space-between;\n      }\n    }\n\n    .bulkActionsContainer {\n      .bulkActionsHeader {\n        flex-direction: column;\n        align-items: flex-start;\n      }\n    }\n\n    .tableContainer {\n      .table {\n        th, td {\n          padding: 8px 4px;\n          font-size: 12px;\n        }\n\n        td.actionButtons {\n          flex-direction: column;\n          gap: 3px;\n\n          .actionButton {\n            width: 100%;\n            justify-content: center;\n          }\n        }\n      }\n    }\n\n    .paginationContainer {\n      flex-direction: column;\n      text-align: center;\n\n      .paginationButtons {\n        justify-content: center;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dataUpdateContainer": `updatedata_dataUpdateContainer__MMyzg`,
	"header": `updatedata_header__iNzGK`,
	"subtitle": `updatedata_subtitle__Rfvii`,
	"controlsContainer": `updatedata_controlsContainer__bj8Bt`,
	"searchSection": `updatedata_searchSection__TfIza`,
	"searchBox": `updatedata_searchBox__aC2-u`,
	"searchInput": `updatedata_searchInput__-NRzg`,
	"searchButton": `updatedata_searchButton__oH9qO`,
	"filterSection": `updatedata_filterSection__uDKKU`,
	"filterInput": `updatedata_filterInput__wKsmh`,
	"actionsSection": `updatedata_actionsSection__pNzej`,
	"sortSection": `updatedata_sortSection__yXJtm`,
	"sortSelect": `updatedata_sortSelect__h8YFH`,
	"sortButton": `updatedata_sortButton__xgaMv`,
	"itemsPerPageContainer": `updatedata_itemsPerPageContainer__57jN3`,
	"itemsPerPageSelect": `updatedata_itemsPerPageSelect__nVSXt`,
	"bulkActionsContainer": `updatedata_bulkActionsContainer__k2stU`,
	"bulkActionsHeader": `updatedata_bulkActionsHeader__sfdbJ`,
	"selectAllLabel": `updatedata_selectAllLabel__3+pPn`,
	"selectAllCheckbox": `updatedata_selectAllCheckbox__3VsRj`,
	"bulkActionButtons": `updatedata_bulkActionButtons__iC3B8`,
	"bulkActionButton": `updatedata_bulkActionButton__iBRu-`,
	"deleteButton": `updatedata_deleteButton__fad2g`,
	"exportButton": `updatedata_exportButton__ebeTh`,
	"loadingContainer": `updatedata_loadingContainer__2vXHz`,
	"loadingSpinner": `updatedata_loadingSpinner__KtoUF`,
	"spin": `updatedata_spin__RcrHi`,
	"tableContainer": `updatedata_tableContainer__umkHQ`,
	"table": `updatedata_table__IzbIH`,
	"checkboxColumn": `updatedata_checkboxColumn__KUAYo`,
	"formNumber": `updatedata_formNumber__hXZaa`,
	"officeName": `updatedata_officeName__obeo-`,
	"ledgerPage": `updatedata_ledgerPage__D837B`,
	"itemName": `updatedata_itemName__PbbsY`,
	"officeAddress": `updatedata_officeAddress__Q1zIm`,
	"actionButtons": `updatedata_actionButtons__HqLmm`,
	"actionButton": `updatedata_actionButton__kKiBj`,
	"editButton": `updatedata_editButton__O2yBV`,
	"viewButton": `updatedata_viewButton__iAnEs`,
	"duplicateButton": `updatedata_duplicateButton__R6IG+`,
	"selectedRow": `updatedata_selectedRow__IKOka`,
	"paginationContainer": `updatedata_paginationContainer__Iw3uG`,
	"paginationInfo": `updatedata_paginationInfo__-i1Zd`,
	"paginationButtons": `updatedata_paginationButtons__REHsU`,
	"paginationButton": `updatedata_paginationButton__hqn+l`,
	"activePage": `updatedata_activePage__XYGOE`,
	"noDataContainer": `updatedata_noDataContainer__SvIjC`,
	"noDataIcon": `updatedata_noDataIcon__8In-v`,
	"noDataSubtext": `updatedata_noDataSubtext__TwS4C`
};
export default ___CSS_LOADER_EXPORT___;
